module.exports = __webpack_public_path__ + "assets/c26ecfb42cac709c27c9a4757d367548.png";